<!-- Network Errorダイアログ -->
<template>
  <b-modal
    v-model="$store.state.error.NetworkErrorModalShow"
    :title="'エラー'"
    :ok-title="'再読み込み'"
    @ok="reload"
    ok-only
    hide-header-close
    footer-class="ok-only">
    <p>現在サインアウトしています。</p>
    <p>もう一度ログインするには、「再読み込み」を押してください。</p>
  </b-modal>
</template>

<script>
export default {
  methods: {
    reload () {
      this.$router.go({ path: this.$router.currentRoute.path, force: true })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  text-align: left;
  margin-bottom: 0;
}
</style>
